import type { SxStyle } from '@aibees/shared/theme';

export const root: SxStyle = {
  height: '100%',
  display: 'flex',
};

export const row: SxStyle = {
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'space-between',
};

export const content: SxStyle = {
  display: 'flex',
  flexDirection: 'column',
  gap: (p) => p.spacing(1.5),
};

export const formElements: SxStyle = {
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
};

export const action: SxStyle = {
  pt: 0,
  justifyContent: 'space-around',
};

export const label: SxStyle = {
  color: (p) => p.palette.common.black,
  fontSize: (p) => p.typography.caption.fontSize,
  fontWeight: (p) => p.typography.fontWeightSemiBold,
};

export const dashed: SxStyle = {
  borderStyle: 'dashed',
};

export const form: SxStyle = {
  justifyContent: 'space-between',
};

export const submitButton: SxStyle = {
  whiteSpace: 'nowrap',
};
